/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Search_FiltersInputs */

const id_search_filters = /** @type {(inputs: Search_FiltersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filter`)
};

const ms_search_filters = /** @type {(inputs: Search_FiltersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Penapis`)
};

const da_search_filters = /** @type {(inputs: Search_FiltersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filtre`)
};

const de_search_filters = /** @type {(inputs: Search_FiltersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filter`)
};

const en_us2_search_filters = /** @type {(inputs: Search_FiltersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filters`)
};

const es_es2_search_filters = /** @type {(inputs: Search_FiltersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filtros`)
};

const es_mx2_search_filters = /** @type {(inputs: Search_FiltersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filtros`)
};

const fil_search_filters = /** @type {(inputs: Search_FiltersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mga Filter`)
};

const fr_search_filters = /** @type {(inputs: Search_FiltersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filtres`)
};

const it_search_filters = /** @type {(inputs: Search_FiltersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filtri`)
};

const hu_search_filters = /** @type {(inputs: Search_FiltersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Szűrők`)
};

const nl_search_filters = /** @type {(inputs: Search_FiltersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filters`)
};

const no_search_filters = /** @type {(inputs: Search_FiltersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filtre`)
};

const pl_search_filters = /** @type {(inputs: Search_FiltersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filtry`)
};

const pt_br2_search_filters = /** @type {(inputs: Search_FiltersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filtros`)
};

const pt_search_filters = /** @type {(inputs: Search_FiltersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filtros`)
};

const ro_search_filters = /** @type {(inputs: Search_FiltersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filtre`)
};

const fi_search_filters = /** @type {(inputs: Search_FiltersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suodattimet`)
};

const sv_search_filters = /** @type {(inputs: Search_FiltersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filter`)
};

const vi_search_filters = /** @type {(inputs: Search_FiltersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bộ lọc`)
};

const tr_search_filters = /** @type {(inputs: Search_FiltersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filtreler`)
};

const cs_search_filters = /** @type {(inputs: Search_FiltersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filtry`)
};

const bg_search_filters = /** @type {(inputs: Search_FiltersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Филтри`)
};

const ru_search_filters = /** @type {(inputs: Search_FiltersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Фильтры`)
};

const uk_search_filters = /** @type {(inputs: Search_FiltersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Фільтри`)
};

const ar_search_filters = /** @type {(inputs: Search_FiltersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`عوامل التصفية`)
};

const hi_search_filters = /** @type {(inputs: Search_FiltersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`फ़िल्टर`)
};

const th_search_filters = /** @type {(inputs: Search_FiltersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ตัวกรอง`)
};

const ja_search_filters = /** @type {(inputs: Search_FiltersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`フィルター`)
};

const zh_cn2_search_filters = /** @type {(inputs: Search_FiltersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`筛选器`)
};

const zh_hant1_search_filters = /** @type {(inputs: Search_FiltersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`篩選器`)
};

const ko_search_filters = /** @type {(inputs: Search_FiltersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`필터`)
};

/**
* | output |
* | --- |
* | "Filters" |
*
* @param {Search_FiltersInputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const search_filters = /** @type {((inputs?: Search_FiltersInputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Search_FiltersInputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_search_filters(inputs)
	if (locale === "ms") return ms_search_filters(inputs)
	if (locale === "da") return da_search_filters(inputs)
	if (locale === "de") return de_search_filters(inputs)
	if (locale === "en-US") return en_us2_search_filters(inputs)
	if (locale === "es-ES") return es_es2_search_filters(inputs)
	if (locale === "es-MX") return es_mx2_search_filters(inputs)
	if (locale === "fil") return fil_search_filters(inputs)
	if (locale === "fr") return fr_search_filters(inputs)
	if (locale === "it") return it_search_filters(inputs)
	if (locale === "hu") return hu_search_filters(inputs)
	if (locale === "nl") return nl_search_filters(inputs)
	if (locale === "no") return no_search_filters(inputs)
	if (locale === "pl") return pl_search_filters(inputs)
	if (locale === "pt-BR") return pt_br2_search_filters(inputs)
	if (locale === "pt") return pt_search_filters(inputs)
	if (locale === "ro") return ro_search_filters(inputs)
	if (locale === "fi") return fi_search_filters(inputs)
	if (locale === "sv") return sv_search_filters(inputs)
	if (locale === "vi") return vi_search_filters(inputs)
	if (locale === "tr") return tr_search_filters(inputs)
	if (locale === "cs") return cs_search_filters(inputs)
	if (locale === "bg") return bg_search_filters(inputs)
	if (locale === "ru") return ru_search_filters(inputs)
	if (locale === "uk") return uk_search_filters(inputs)
	if (locale === "ar") return ar_search_filters(inputs)
	if (locale === "hi") return hi_search_filters(inputs)
	if (locale === "th") return th_search_filters(inputs)
	if (locale === "ja") return ja_search_filters(inputs)
	if (locale === "zh-CN") return zh_cn2_search_filters(inputs)
	if (locale === "zh-Hant") return zh_hant1_search_filters(inputs)
	return ko_search_filters(inputs)
});
export { search_filters as "search.filters" }